module.exports = __webpack_public_path__ + "static/img/阵雨.e00f9335.svg";